module.exports = __webpack_public_path__ + "static/media/arrow-back-mobile.33fe2a71.svg";